import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faStar } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss']
})
export class GenericTableComponent implements OnChanges {
  @Input() columns: { header: string; field: string; }[] = [];
  @Input() data: any[] = [];
  @Input() loading: boolean = false;
  @Input() actions: { icon: any; view: any; action: (row: any) => void; tooltip?: string; }[] = [];
 icons = {
   
    homeUser: faStar,




  }
  displayedData: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.displayedData = this.data;
    }
  }

  onAction(act: any, row: any) {
    if (act.action) act.action(row);
  }
}